import * as angular from 'angular';

import AbbreviatedNumberWithSuffixFilter from './abbreviatedNumberWithSuffix.filter';
import EllipsisFilter from './ellipsis.filter';
import FormatPlannedSpendLevelFilter from './formatPlannedSpendLevel.filter';
import { FormatDateFilter, Timezones } from './formatDate.filter';
import MaskFilter from './mask.filter';
import MultilineEllipsisDirective from './multilineEllipsis.directive';
import { NfCurrencyFilter, NfCurrencyNumericFilter } from './nfCurrency.filter';
import NumberOrNAFilter from './numberOrNA.filter';
import PercentageFilter from './percentage.filter';
import PrefixSuffixFilter from './prefixSuffix.filter';
import PriceToKStringListFilter from './priceToKStringList.filter';
import TitleCase from './titlecase.filter';
import ToNegativeFilter from './toNegative.filter';
import SpendBySpendLevelFieldName from './spendBySpendLevelFieldName.filter';
import SpendAndSavingsSummaryFilter from './spendAndSavingsSummary.filter';
import FormatComboTierSpendLevelFilter from './formatComboTierSpendLevel.filter';
import SpendLevelValue from './spendLevelValue.filter';

export default angular
  .module('core.format', [])
  .constant('TIMEZONES', Timezones)
  .filter('abbreviatedNumberWithSuffix', AbbreviatedNumberWithSuffixFilter)
  .filter('ellipsis', EllipsisFilter)
  .filter('formatDate', FormatDateFilter)
  .filter('formatPlannedSpendLevel', FormatPlannedSpendLevelFilter)
  .filter('mask', MaskFilter)
  .directive('multilineEllipsis', MultilineEllipsisDirective)
  .filter('nfcurrency', NfCurrencyFilter)
  .filter('nfcurrencyNumeric', NfCurrencyNumericFilter)
  .filter('numberOrNA', NumberOrNAFilter)
  .filter('percentage', PercentageFilter)
  .filter('priceToKStringList', PriceToKStringListFilter)
  .filter('titleCase', TitleCase)
  .filter('toNegative', ToNegativeFilter)
  .filter('prefixSuffix', PrefixSuffixFilter)
  .filter('spendBySpendLevelFieldName', SpendBySpendLevelFieldName)
  .filter('spendAndSavingsSummary', SpendAndSavingsSummaryFilter)
  .filter('spendLevelValue', SpendLevelValue)
  .filter('formatComboTierSpendLevel', FormatComboTierSpendLevelFilter).name;
